export default {
    backgroundColor: "#cee4e5",
    borderRadius: '5px',
}